import AdminResultEntry from './AdminResultEntry';

const AdminEnterCBT = () => <AdminResultEntry assessmentType="cbt" />;

export default AdminEnterCBT;
